import { usePage } from '@inertiajs/react'
import UnitForm from './UnitForm'
import { t } from '@/shared/lib/i18n'
import { departmentsPath, unitPath, unitsPath, organizationPath } from '@/shared/lib/routes'
import { useBreadcrumbs } from '@/shared/lib/breadcrumbs-context'
import type { WebUnitForm } from '@/shared/types/web'
import type { WeekdaySchedule } from '@/shared/ui/weekly-schedule-grid'

interface DepartmentOption {
  value: number
  label: string
  siteName: string | null
}

interface Props {
  departments: DepartmentOption[]
  unit: WebUnitForm
  customDaySchedule: WeekdaySchedule
  parentDaySchedule: WeekdaySchedule
  [key: string]: unknown
}

const EditUnitPage = () => {
  const { departments, unit, customDaySchedule, parentDaySchedule } = usePage<Props>().props

  useBreadcrumbs([
    { label: t('nav.administration'), href: organizationPath() },
    { label: t('nav.departmentsAndUnits'), href: departmentsPath() },
    { label: t('nav.units'), href: unitsPath() },
    { label: t('organization.units.editTitle') },
  ])

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">
        {t('organization.units.editTitle')}: {unit.name}
      </h1>
      <UnitForm
        departments={departments}
        initialData={unit}
        customDaySchedule={customDaySchedule}
        parentDaySchedule={parentDaySchedule}
        submitUrl={unitPath(unit.id)}
        submitMethod="patch"
      />
    </div>
  )
}

export default EditUnitPage
